(() => {
  const GROUP_SELECTOR = "[data-pawkivo-reveal-group]";
  const ITEM_SELECTOR = "[data-pawkivo-reveal-item]";
  const READY_CLASS = "is-pawkivo-reveal-ready";
  const REVEALED_CLASS = "is-pawkivo-revealed";
  const ITEM_REVEAL_MODE = "items";

  const reveal = (element) => {
    element.classList.add(REVEALED_CLASS);
  };

  const prepareItem = (group, item, index) => {
    const stagger = Number(group.dataset.pawkivoRevealStagger || 90);
    const explicitDelay = item.dataset.pawkivoRevealDelay;
    const delay = explicitDelay !== undefined ? Number(explicitDelay) : index * stagger;

    if (Number.isFinite(delay)) {
      item.style.setProperty("--pawkivo-reveal-delay", `${delay}ms`);
    }
  };

  const prepareItems = (group, items = group.querySelectorAll(ITEM_SELECTOR)) => {
    items.forEach((item, index) => {
      prepareItem(group, item, index);
    });
  };

  const groupObserver =
    "IntersectionObserver" in window
      ? new IntersectionObserver(
          (entries, activeObserver) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;

              reveal(entry.target);
              activeObserver.unobserve(entry.target);
            });
          },
          {
            rootMargin: "0px 0px -12% 0px",
            threshold: 0.16,
          }
        )
      : null;

  const itemObserver =
    "IntersectionObserver" in window
      ? new IntersectionObserver(
          (entries, activeObserver) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;

              reveal(entry.target);
              activeObserver.unobserve(entry.target);
            });
          },
          {
            rootMargin: "600px 0px 600px 0px",
            threshold: 0.01,
          }
        )
      : null;

  const observeItem = (item) => {
    if (item.classList.contains(REVEALED_CLASS)) return;

    if (itemObserver) {
      itemObserver.observe(item);
    } else {
      reveal(item);
    }
  };

  const watchNewItems = (group) => {
    if (group.dataset.pawkivoRevealWatching === "true" || !("MutationObserver" in window)) return;

    const mutationObserver = new MutationObserver((mutations) => {
      const newItems = [];

      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;

          if (node.matches?.(ITEM_SELECTOR)) {
            newItems.push(node);
          }

          node.querySelectorAll?.(ITEM_SELECTOR).forEach((item) => {
            newItems.push(item);
          });
        });
      });

      newItems.forEach((item, index) => {
        prepareItem(group, item, index);
        observeItem(item);
      });
    });

    mutationObserver.observe(group, {
      childList: true,
    });
    group.dataset.pawkivoRevealWatching = "true";
  };

  const initReveal = (root = document) => {
    const groups = root.matches?.(GROUP_SELECTOR)
      ? [root, ...root.querySelectorAll(GROUP_SELECTOR)]
      : root.querySelectorAll(GROUP_SELECTOR);

    groups.forEach((group) => {
      if (group.classList.contains(READY_CLASS)) return;

      if (group.matches(ITEM_SELECTOR)) prepareItem(group, group, 0);
      prepareItems(group);
      group.classList.add(READY_CLASS);

      if (group.dataset.pawkivoRevealMode === ITEM_REVEAL_MODE) {
        group.querySelectorAll(ITEM_SELECTOR).forEach(observeItem);
        watchNewItems(group);
      } else if (groupObserver) {
        groupObserver.observe(group);
      } else {
        reveal(group);
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initReveal());
  } else {
    initReveal();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initReveal(event.target);
  });
})();
